import { render } from "./ViewersDetail.vue?vue&type=template&id=12a426f8&scoped=true"
import script from "./ViewersDetail.vue?vue&type=script&lang=js"
export * from "./ViewersDetail.vue?vue&type=script&lang=js"

import "./ViewersDetail.vue?vue&type=style&index=0&id=12a426f8&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a426f8"]])

export default __exports__